
export const extractStepNumber = (stepString: string) => {
  const match = stepString.match(/\d+/); // Finds digits in the string
  return match ? parseInt(match[0], 10) : null; // Returns number or null if no match
}
